import { gql } from "@apollo/client";

import { ArtifactActivityFragment } from "@apps/artifact-sidebar/graphql/get-artifact-activities-query";

export const ProfileArtifactActivityFragment = gql`
  ${ArtifactActivityFragment}
  fragment ProfileArtifactActivityFragment on ArtifactActivityNode {
    ...ArtifactActivityFragment
    artifact {
      id
      artifactType
      title
      ... on DecisionArtifactNode {
        decision
      }
      ... on GoalArtifactNode {
        scope
      }
    }
  }
`;

export default gql`
  ${ProfileArtifactActivityFragment}
  query getProfileActivitiesQuery(
    $profileId: Int!
    $after: String
    $createdAfter: DateTime
  ) {
    user(userId: $profileId) {
      id
      activities(first: 5, after: $after, createdAfter: $createdAfter) {
        edges {
          node {
            ...ProfileArtifactActivityFragment
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
